
import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import gregorian from "react-date-object/calendars/gregorian";
export default function DateTimeRangeFilter({ onApplyFilter, buttonText = "فیلتر زمانی", onClearFilter }) {
    const [open, setOpen] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [displayValue, setDisplayValue] = useState(buttonText);

    const popupRef = useRef(null);
    const buttonRef = useRef(null);

    // close on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                popupRef.current &&
                !popupRef.current.contains(e.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(e.target)
            ) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const formatDate = (d) =>
        d ? `${d.format("YYYY/MM/DD")} (${d.format("HH:mm")})` : "";

    const handleApply = () => {
        if (!fromDate || !toDate) return;

        const fromTimeNotSelected = fromDate.hour == null && fromDate.minute == null;
        const toTimeNotSelected = toDate.hour == null && toDate.minute == null;

        // ✅ نگه داشتن حالت شمسی
        const fixedFrom = new DateObject(fromDate);
        const fixedTo = new DateObject(toDate);

        if (fromTimeNotSelected) {
            fixedFrom.set("hour", 0).set("minute", 0);
        }
        if (toTimeNotSelected) {
            fixedTo.set("hour", 23).set("minute", 59);
        }

        // ✅ حالا تاریخ شمسی نمایش داده می‌شود (بدون تبدیل به میلادی)
        // const fromStr = fixedFrom.format("YYYY/MM/DD HH:mm");
        // const toStr = fixedTo.format("YYYY/MM/DD HH:mm");
        // setDisplayValue(`${fromStr} تا ${toStr}`);
        setOpen(false);

        // فقط برای ارسال به بک‌اند یا ذخیره لوکال، میلادی کن
        const startDate = fixedFrom.convert(persian, persian_fa).toDate().toISOString();
        const endDate = fixedTo.convert(persian, persian_fa).toDate().toISOString();

        localStorage.setItem("startDate", startDate);
        localStorage.setItem("endDate", endDate);

        onApplyFilter?.({ startDate, endDate });
    };

    const setQuickRange = (type) => {
        // زمان فعلی سیستم با تقویم شمسی
        const now = new DateObject({ calendar: persian, locale: persian_fa });

        let baseFrom;

        if (type === "60days") {
            baseFrom = new DateObject({ calendar: persian, locale: persian_fa }).subtract(60, "days");
        } else if (type === "30days") {
            baseFrom = new DateObject({ calendar: persian, locale: persian_fa }).subtract(30, "days");
        } else if (type === "7days") {
            baseFrom = new DateObject({ calendar: persian, locale: persian_fa }).subtract(7, "days");
        } else {
            // حذف فیلتر
            setFromDate(null);
            setToDate(null);
            setDisplayValue(buttonText);
            localStorage.removeItem("startDate");
            localStorage.removeItem("endDate");
            onApplyFilter?.(null);
            return;
        }

        // شروع روز از ساعت ۰
        const fromDateObj = new DateObject({
            year: baseFrom.year,
            month: baseFrom.month,
            day: baseFrom.day,
            hour: 0,
            minute: 0,
            calendar: persian,
            locale: persian_fa,
        });

        // پایان همان لحظه فعلی سیستم
        const toDateObj = new DateObject({
            year: now.year,
            month: now.month,
            day: now.day,
            hour: now.hour,
            minute: now.minute,
            calendar: persian,
            locale: persian_fa,
        });

        // آپدیت state‌ها
        setFromDate(fromDateObj);
        setToDate(toDateObj);

        // نمایش شمسی در UI
        // setDisplayValue(`${fromDateObj.format("YYYY/MM/DD HH:mm")} تا ${toDateObj.format("YYYY/MM/DD HH:mm")}`);
        setOpen(false);

        // ارسال میلادی برای بک‌اند
        const startDate = fromDateObj.convert(gregorian).toDate().toISOString();
        const endDate = toDateObj.convert(gregorian).toDate().toISOString();

        localStorage.setItem("startDate", startDate);
        localStorage.setItem("endDate", endDate);
        onApplyFilter?.({ startDate, endDate });
    };

    const handleClear = () => {
        setFromDate(null);
        setToDate(null);
        setDisplayValue(buttonText);
        localStorage.removeItem("startDate");
        localStorage.removeItem("endDate");
        const now = new DateObject({ calendar: persian, locale: persian_fa });
        const from = new DateObject({ calendar: persian }).subtract(30, "days");

        // onApplyFilter?.({
        //     startDate: from.toDate().toISOString(),
        //     endDate: now.toDate().toISOString(),
        // });
        onClearFilter?.();

    }
    // helper now/time string to use in maxTime
    const now = new DateObject({ calendar: persian, locale: persian_fa });
    const nowTimeStr = `${String(now.hour).padStart(2, "0")}:${String(now.minute).padStart(2, "0")}`;
    const disableFutureTime = (hour, minute) => {
        const nowObj = new DateObject({ calendar: persian, locale: persian_fa });
        return hour > nowObj.hour || (hour === nowObj.hour && minute > nowObj.minute);
    };

    return (
        <div className="relative inline-block text-right">
            <button
                ref={buttonRef}
                onClick={() => setOpen(!open)}
                className={`flex items-center gap-1 px-3 py-2 bg-transparent hover:bg-gray-50 transition-all 
                duration-200 text-gray-700 font-bold text-[15px]  `}
                aria-expanded={open}
            >
                {displayValue == "فیلتر زمانی" && <CalendarDaysIcon className="w-10 h-10 text-[#1c4747]" />}

                <span className="text-[#1c4747] mt-2 text-md">{displayValue}</span>
            </button>

            <div
                ref={popupRef}
                className={`absolute top-full mb-3 right-0 w-96 max-w-[90vw] bg-white border border-gray-200 shadow-xl rounded-xl p-5 z-50 transform transition-all duration-200 origin-bottom ${open ? "opacity-100 scale-100 visible" : "opacity-0 scale-95 invisible"}`}
            >
                <div className="flex flex-col gap-5">
                    <div className="flex flex-row justify-between items-center gap-x-5">
                        <div className="flex-col justify-center items-center gap-y-5 ">
                            {/* از تاریخ */}
                            <div className="" >
                                <label className="text-sm font-medium text-gray-700 mb-1 block">از تاریخ</label>
                                <DatePicker
                                    value={fromDate}
                                    onChange={(date) => {
                                        if (!date) {
                                            setFromDate(null);
                                            return;
                                        }

                                        if (date) {
                                            const newDate = new DateObject(date, { calendar: persian, locale: persian_fa });
                                            const nowObj = new DateObject({ calendar: persian, locale: persian_fa });

                                            // اگر تاریخ امروز هست و کاربر ساعت نزده، ساعت رو صفر قرار بده
                                            if (newDate.format("YYYY/MM/DD") !== nowObj.format("YYYY/MM/DD")) {
                                                if (newDate.hour == null && newDate.minute == null) {
                                                    newDate.set("hour", 0).set("minute", 0);
                                                }
                                            } else {
                                                // تاریخ امروز، اجازه ساعت بیشتر از الان نده
                                                if (newDate.hour == null && newDate.minute == null) {
                                                    newDate.set("hour", 0).set("minute", 0);
                                                } else if (newDate.hour > nowObj.hour || (newDate.hour === nowObj.hour && newDate.minute > nowObj.minute)) {
                                                    newDate.set("hour", nowObj.hour).set("minute", nowObj.minute);
                                                }
                                            }


                                            // create fresh instance from toDate() to avoid shared refs
                                            setFromDate(new DateObject(newDate.toDate(), { calendar: persian, locale: persian_fa }));
                                        } else {
                                            setFromDate(null);
                                        }
                                    }}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    // calendarPosition="auto"
                                    // portal={false}
                                    // portal
                                    plugins={[<TimePicker hideSeconds={true} position="right" hideOnSelect={false} input={false}
                                    />]}
                                    maxDate={new DateObject({ calendar: persian })}
                                    minDate={new DateObject({ calendar: persian }).subtract(3, "month")}
                                    closeOnSelect={false}
                                    inputClass="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 h-full"
                                    format="YYYY/MM/DD HH:mm"
                                    renderFooter={({ closeCalendar }) => (
                                        <button
                                            className="mt-2 w-full bg-blue-600 text-white py-1 rounded-lg text-sm hover:bg-blue-700 transition-all"
                                            onClick={() => closeCalendar()}
                                        >
                                            ثبت
                                        </button>
                                    )}
                                // className=" mt-20"
                                />
                            </div>

                            {/* تا تاریخ */}
                            <div className="mt-5">
                                <label className="text-sm font-medium text-gray-700 mb-1 block">تا تاریخ</label>
                                <DatePicker
                                    value={toDate}
                                    onChange={(date) => {
                                        if (!date) {
                                            setToDate(null);
                                            return;
                                        }

                                        const newDate = new DateObject(date, { calendar: persian, locale: persian_fa });
                                        const nowObj = new DateObject({ calendar: persian, locale: persian_fa });



                                        // if (newDate.format("YYYY/MM/DD") === nowObj.format("YYYY/MM/DD")) {
                                        //   // تاریخ امروز، ساعت بیشتر از الان نشه
                                        //   if (newDate.hour == null && newDate.minute == null) {
                                        //     newDate.set("hour", nowObj.hour).set("minute", nowObj.minute);
                                        //   } else if (newDate.hour > nowObj.hour || (newDate.hour === nowObj.hour && newDate.minute > nowObj.minute)) {
                                        //     newDate.set("hour", nowObj.hour).set("minute", nowObj.minute);
                                        //   }
                                        // } else {
                                        //   // تاریخ گذشته، اگر ساعت نزده باشه 23:59 بذار
                                        //   if (newDate.hour == null && newDate.minute == null) {
                                        //     newDate.set("hour", 23).set("minute", 59);
                                        //   }
                                        // }

                                        // اگر تاریخ امروز هست، ساعت بیشتر از الان نشه
                                        if (newDate.format("YYYY/MM/DD") === nowObj.format("YYYY/MM/DD")) {
                                            if (newDate.hour == null && newDate.minute == null) {
                                                newDate.set("hour", nowObj.hour).set("minute", nowObj.minute);
                                            } else if (newDate.hour > nowObj.hour || (newDate.hour === nowObj.hour && newDate.minute > nowObj.minute)) {
                                                newDate.set("hour", nowObj.hour).set("minute", nowObj.minute);
                                            }
                                        } else {
                                            // تاریخ گذشته، اگر ساعت نزده باشه 23:59 بذار
                                            if (newDate.hour == null && newDate.minute == null) {
                                                newDate.set("hour", 23).set("minute", 59);
                                            }
                                        }

                                        // **شرط اضافه: اگر fromDate هست و تاریخ‌ها یکسانه، toDate باید بعد از fromDate باشه**
                                        if (fromDate && newDate.format("YYYY/MM/DD") === fromDate.format("YYYY/MM/DD")) {
                                            const fromMinutes = (fromDate.hour ?? 0) * 60 + (fromDate.minute ?? 0);
                                            const toMinutes = (newDate.hour ?? 0) * 60 + (newDate.minute ?? 0);
                                            if (toMinutes <= fromMinutes) {
                                                newDate.set("hour", fromDate.hour ?? 0).set("minute", (fromDate.minute ?? 0) + 1);
                                                if (newDate.minute >= 60) {
                                                    newDate.set("hour", (newDate.hour + 1) % 24).set("minute", 0);
                                                }
                                            }
                                        }
                                        setToDate(new DateObject(newDate.toDate(), { calendar: persian, locale: persian_fa }));
                                    }}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    // calendarPosition="auto"
                                    // portal
                                    plugins={[
                                        <TimePicker
                                            hideSeconds
                                            position="right"
                                            hideOnSelect={false}
                                            input={false}

                                        />
                                    ]}
                                    maxDate={new DateObject({ calendar: persian })}
                                    minDate={fromDate ? new DateObject(fromDate.toDate(), { calendar: persian, locale: persian_fa }) : new DateObject({ calendar: persian }).subtract(1, "month")}
                                    closeOnSelect={false}
                                    inputClass="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    format="YYYY/MM/DD HH:mm"
                                />


                            </div>
                        </div>

                        {/* دکمه‌های میانبر */}
                        <div className="flex flex-col flex-wrap  justify-center  gap-y-5 ">
                            <button onClick={() => setQuickRange("7days")} className="text-xs bg-[#FFC505] hover:bg-[#ff9b05] px-3 py-2 rounded-lg transition">۷ روز گذشته</button>
                            <button onClick={() => setQuickRange("30days")} className="text-xs bg-[#FFC505] hover:bg-[#ff9b05] px-3 py-2 rounded-lg transition">30 روز گذشته</button>
                            <button onClick={() => setQuickRange("60days")} className="text-xs bg-[#FFC505] hover:bg-[#ff9b05] px-3 py-2 rounded-lg transition">60 روز گذشته</button>
                        </div>

                    </div>

                    <div className="flex justify-between items-center">
                        <button
                            type="button"
                            onClick={() => {
                                console.log("🔥🔥🔥 APPLY CLICKED");
                                handleApply();
                            }}
                            style={{
                                position: "relative",
                                zIndex: 99999,
                                pointerEvents: "auto",
                            }}
                            className="w-[56%] py-2 px-3 rounded-lg bg-red-500 text-white"
                        >
                            اعمال فیلتر
                        </button>
                        <button onClick={handleClear} className=" w-[26%] text-xs text-red-600 hover:bg-red-50 px-3 rounded-lg transition border-2 border-red-500 py-2">پاک کردن</button>
                    </div>
                </div>
            </div>
        </div>
    );
}